import {api} from "@/app/services/api.service";

const state = {
  business_annual_returns:{},
  business_annual_returns_escalations:null,
  business_annual_returns_details_error:null,
  business_annual_returns_details:null,
  business_annual_returns_year_details:null,
  business_annual_returns_task:null,
  business_annual_returns_task_count:{},
  business_annual_returns_stats:{},
  business_annual_returns_task_messages:null,
  success_escalation:null,
  business_annual_returns_payment_removed:null,
  business_error:null,
  success:{},
  business_annual_returns_success_final_decision:null,

};

const getters = {
  getBusinessAnnualReturnsSubmissions: (state) => state.business_annual_returns,
  getBusinessAnnualReturnsEscalations: (state) => state.business_annual_returns_escalations,
  getBusinessAnnualReturnsTaskMessages: (state) => state.business_annual_returns_task_messages,
  getBusinessAnnualReturnsStatistics: (state) => state.business_annual_returns_stats,
  getBusinessAnnualReturnsTaskCount: (state) => state.business_annual_returns_task_count,
  getBusinessAnnualReturnsTask: (state) => state.business_annual_returns_task,
  getBusinessAnnualReturnsYearDetails: (state) => state.business_annual_returns_year_details,
  getBusinessAnnualReturnsTaskError: (state) => state.error,
  getBusinessAnnualReturnsAssignmentError: (state) => state.business_error,
  getBusinessAnnualReturnsUpdateStatusSuccess: (state) => state.business_annual_returns_success_final_decision,
  getBusinessAnnualReturnsEscalationSuccess:(state) => state.success_escalation,
  getBusinessAnnualReturnsAssignmentSuccess: (state) => state.success,
  getBusinessAnnualReturnsUpdateStatusSuccessError: (state) => state.business_error,
  getBusinessAnnualReturnsDetails: (state) => state.business_annual_returns_details,
  getBusinessAnnualReturnPaymentRemoved: (state) => state.business_annual_returns_payment_removed,
  getBusinessAnnualReturnsDetailsError: (state) => state.business_annual_returns_details_error,
};

const actions = {
  async fetchBusinessAnnualReturnsSubmissions({commit}, data){
    let path = "/business-registration-v2/annual-return-forms?status="+data.status+"&page="+data.page+"&pageSize="+data.limit
    if(data.search !== ""){
      path += "&search="+data.search
    }
    api().get(path).
    then(response => {
      commit('setBusinessAnnualReturnsSubmissions', response.data);
    }).catch(error => {
      commit("setBusinessAnnualReturnsError", error.response)
    });
  },
  async fetchBusinessAnnualReturnsEscalations({commit}, data){
    return api().get("/business-registration-v2/annual-return-escalations?status="+data.statuses+"&page="+data.page+"&perPage="+data.limit).
    then(response => {
      commit('setBusinessAnnualReturnsEscalations', response.data);
      return response.data;
    }).catch(error => {
      commit("setBusinessAnnualReturnsError", error.response)
      throw error;
    });
  },
  async fetchBusinessAnnualReturnsMessages({commit}, trackingNumber){
    api().get("/business-registration-v2/annual-return-queue/status/"+encodeURIComponent(trackingNumber)).
    then(response => {
      commit('setBusinessAnnualReturnsMessages', response.data);
    }).catch(error => {
      commit("setBusinessAnnualReturnsError", error.response)
    });
  },
  async fetchBusinessAnnualReturnsTask({commit}){
    api().get("/business-registration-v2/annual-return-queue/next").
    then(response => {
      commit('setBusinessAnnualReturnsTask', response.data);
    }).catch(error => {
      commit("setBusinessAnnualReturnsError", error.response)
    });
  },
  async fetchBusinessAnnualReturnsEscalation({commit}, escalationId){
    api().get("/business-registration-v2/annual-return-escalations/"+escalationId).
    then(response => {
      commit('setBusinessAnnualReturnsTask', response.data);
    }).catch(error => {
      commit("setBusinessAnnualReturnsError", error.response)
    });
  },
  async fetchBusinessAnnualReturnYearDetails({commit}, year, trackingNumber){
    api().get("/business-registration-v2/annual-return-forms/"+trackingNumber+"/return/"+year).
    then(response => {
      commit('setBusinessAnnualReturnsYearDetails', response.data);
    }).catch(error => {
      commit("setBusinessAnnualReturnsError", error.response)
    });
  },
  async fetchBusinessAnnualReturnsTaskCount({commit}){
    api().get("/business-registration-v2/annual-return-queue/count").
    then(response => {
      commit('setBusinessAnnualReturnsCount', response.data);
    }).catch(error => {
      commit("setBusinessAnnualReturnsError", error.response)
    });
  },
  async fetchBusinessAnnualReturnsStatistics({commit}){
    api().get("/business-registration-v2/annual-return-queue/basic-statistics").
    then(response => {
      const payload = response?.data?.data ?? response?.data ?? {}
      commit('setBusinessAnnualReturnsStats', payload);
    }).catch(error => {
      commit("setBusinessAnnualReturnsError", error.response)
    });
  },
  async assignBusinessAnnualReturnsTask({commit}, data){
    const payload = {
      trackingNumber: data.trackingNumber,
      registrarId: data.registrarId,
      reason: data.reason != null ? data.reason : "",
    };
    api().post("/business-registration-v2/annual-return-queue/assign", payload).
    then(response => {
      commit('setBusinessAnnualReturnsAssignmentSuccess', response.data);
    }).catch(error => {
      commit("setBusinessAnnualReturnsError", error.response)
    });
  },
  async escalateBusinessAnnualReturnsTask({commit}, data){
    api().post("/business-registration-v2/annual-return-escalations", data).
    then(response => {
      commit('setBusinessAnnualReturnsEscalationSuccess', response.data);
    }).catch(error => {
      commit("setBusinessAnnualReturnsError", error.response)
    });
  },
  async updateBusinessAnnualReturnsStatus({commit}, data){
    const payload = {
      trackingNumber: data.trackingNumber,
      status: data.status,
      reason: data.reason != null ? data.reason : "",
    };
    api().post("/business-registration-v2/annual-return-queue/status", payload).
    then(response => {
      commit('setUpdateBusinessAnnualReturnsStatusSuccess', response.data);
    }).catch(error => {
      commit("setBusinessAnnualReturnsStatusUpdateError", error.response)
    });
  },
  async removeBusinessAnnualReturnsPayment({commit}, data){
    api().post("/business-registration-v2/annual-returns/forms/remove-payment-details", data).
    then(response => {
      commit('setRemoveBusinessAnnualReturnsPayment', response.data);
    }).catch(error => {
      commit("setBusinessAnnualReturnsStatusUpdateError", error.response)
    });
  },
  async fetchBusinessAnnualReturnsDetails({commit}, trackingNo){
    api().get("/business-registration-v2/annual-return-forms/"+trackingNo).
    then(response => {
      commit('setBusinessAnnualReturnsDetails', response.data);
    }).catch(error => {
      commit("setBusinessAnnualReturnsDetailsError", error.response)
    });
  },

};

const mutations = {
  setBusinessAnnualReturnsSubmissions: (state, response) =>{
    state.business_annual_returns = response;
  },
  setBusinessAnnualReturnsEscalations: (state, response) =>{
    state.business_annual_returns_escalations = response?.data ?? response ?? null;
  },
  setBusinessAnnualReturnsMessages: (state, response) =>{
    state.business_annual_returns_task_messages = response;
  },
  setBusinessAnnualReturnsTask: (state, response) =>{
    const payload = response?.data ?? response ?? null;
    if (!payload) {
      state.business_annual_returns_task = null;
      return;
    }
    if (payload && typeof payload === "object" && "data" in payload && payload.data == null) {
      state.business_annual_returns_task = null;
      return;
    }

    const isAlreadyNormalized =
      payload &&
      typeof payload === "object" &&
      payload.data &&
      typeof payload.data === "object" &&
      ("taskId" in payload || "createdAt" in payload || "status" in payload);

    if (isAlreadyNormalized) {
      state.business_annual_returns_task = payload;
      return;
    }

    const raw = payload;
    const rawId = raw?.taskId ?? raw?.queueId ?? raw?.id ?? null;
    const rawStatus = raw?.status ?? null;
    const rawCreatedAt = raw?.createdAt ?? null;

    const trackingNo = raw?.trackingNo ?? raw?.trackingNumber ?? null;
    const companyName = raw?.companyName ?? raw?.name ?? null;

    state.business_annual_returns_task = {
      taskId: rawId,
      status: rawStatus,
      createdAt: rawCreatedAt,
      data: {
        ...raw,
        trackingNo,
        companyName,
      },
    };
  },
  setBusinessAnnualReturnsYearDetails: (state, response) =>{
    state.business_annual_returns_year_details = response.data;
  },
  setBusinessAnnualReturnsStats: (state, response) =>{
    const draft = Number(response?.draft ?? 0)
    const awaitingPayment = Number(response?.awaiting_payment ?? 0)
    const submitted = Number(response?.submitted ?? 0)
    const pending = Number(response?.pending ?? (awaitingPayment + submitted))
    const assigned = Number(response?.assigned ?? 0)
    const queried = Number(response?.queried ?? 0)
    const approved = Number(response?.approved ?? 0)
    const escalated = Number(response?.escalated ?? 0)
    const rejected = Number(response?.rejected ?? 0)
    const paymentFailed = Number(response?.payment_failed ?? 0)
    const canceled = Number(response?.canceled ?? 0)
    const total = Number(
      response?.total ??
      (draft + pending + assigned + queried + approved + escalated + rejected + paymentFailed + canceled)
    )

    state.business_annual_returns_stats = {
      draft,
      awaiting_payment: awaitingPayment,
      pending,
      assigned,
      queried,
      approved,
      escalated,
      rejected,
      payment_failed: paymentFailed,
      canceled,
      total,
    };
  },
  setBusinessAnnualReturnsCount: (state, response) =>{
    state.business_annual_returns_task_count = response;
  },
  setBusinessAnnualReturnsAssignmentSuccess: (state, response) =>{
    state.success = response;
  },
  setBusinessAnnualReturnsEscalationSuccess: (state, response) =>{
    state.success_escalation = response;
  },
  setBusinessAnnualReturnsError: (state, response) =>{
    state.business_error = response;
  },
  setUpdateBusinessAnnualReturnsStatusSuccess: (state, response) =>{
    state.business_annual_returns_success_final_decision = response;
  },
  setRemoveBusinessAnnualReturnsPayment: (state, response) =>{
    state.business_annual_returns_payment_removed = response;
  },
  setBusinessAnnualReturnsStatusUpdateError: (state, response) =>{
    state.business_error = response;
  },
  setBusinessAnnualReturnsDetails:(state, response) =>{
    const envelope = response?.data ?? response ?? null
    if(!envelope){
      state.business_annual_returns_details = null
      return
    }
    if(envelope.trackingNumber || envelope.trackingNo){
      state.business_annual_returns_details = envelope
      return
    }
    state.business_annual_returns_details = envelope.data ?? envelope
  },
  setBusinessAnnualReturnsDetailsError:(state, response) =>{
    state.business_annual_returns_details_error = response.data
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};